// bd-deepcontext-b4zw — error-message mapping lifted out of ScheduledJobs.tsx,
// where the same `message || error || fallback` chain was repeated in every
// mutation handler.
import type { BlueprintUsageMap } from "../PromptMultiSelect";

export const extractApiErrorMessage = (err: any, fallback: string): string =>
  err?.response?.data?.message || err?.response?.data?.error || fallback;

// bd-n3yqb — build a clear conflict message from a 409 response, naming each
// offending blueprint and the job that already owns it. The picker disables
// these up front; this backstops the race where a blueprint is claimed between
// opening the form and saving.
export const formatBlueprintConflict = (
  err: any,
  blueprintUsage: BlueprintUsageMap,
): string => {
  const conflicts: Array<{ promptId: string; jobName: string }> =
    err?.response?.data?.conflicts || [];
  if (conflicts.length > 0) {
    const detail = conflicts
      .map((c) => {
        const owner = blueprintUsage[c.promptId];
        const name = owner?.jobName || c.jobName;
        return `blueprint ${c.promptId} is already used by "${name}"`;
      })
      .join("; ");
    return `Cannot save — ${detail}. Remove it and try again.`;
  }
  return extractApiErrorMessage(
    err,
    "A selected blueprint is already used by another scheduled job.",
  );
};
